export default function Footer() {
  const scrollTo = (id: string) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer className="bg-forest-dark text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Brand */}
          <div className="w-full lg:w-[35%]">
            <img
              src="https://static.readdy.ai/image/a853a7261abdde22808a704dea326f3c/12cc32943ef87388ca463c82041471e1.jpeg"
              alt="Montebrisa Boutique B&B Logo"
              className="h-[72px] w-auto object-contain mb-4"
            />
            <p className="font-sans text-sm text-white/65 leading-relaxed mb-5">
              A lovingly restored 1940s Art Déco villa nestled in a tropical oasis, 3 blocks from Matagalpa&apos;s Cathedral. Nicaragua&apos;s most celebrated boutique B&amp;B.
            </p>
            <div className="flex items-center gap-2 text-gold">
              {[1,2,3,4,5].map(s => <i key={s} className="ri-star-fill text-sm" />)}
              <span className="font-sans text-xs text-white/60 ml-1">5-Star · TripAdvisor #1</span>
            </div>
          </div>

          {/* Nav columns */}
          <div className="w-full lg:w-[65%] grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h4 className="font-sans text-xs tracking-widest uppercase text-white/40 mb-4">Explore</h4>
              <ul className="space-y-3">
                {[['#about','About Montebrisa'],['#rooms','Rooms & Suites'],['#gardens','Garden & Landscape'],['#amenities','Amenities']].map(([id, label]) => (
                  <li key={id}>
                    <button onClick={() => scrollTo(id)} className="font-sans text-sm text-white/70 hover:text-gold transition-colors cursor-pointer whitespace-nowrap">
                      {label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="font-sans text-xs tracking-widest uppercase text-white/40 mb-4">Recognition</h4>
              <ul className="space-y-3">
                {[['#awards','Awards & Certs'],['#awards','TripAdvisor Top 1%'],['#awards','GreenLeaders Silver'],['#awards','Certificate of Excellence']].map(([id, label]) => (
                  <li key={label}>
                    <button onClick={() => scrollTo(id)} className="font-sans text-sm text-white/70 hover:text-gold transition-colors cursor-pointer whitespace-nowrap">
                      {label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="font-sans text-xs tracking-widest uppercase text-white/40 mb-4">Visit Us</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-gold text-sm mt-0.5 w-4 h-4 flex items-center justify-center shrink-0" />
                  <span className="font-sans text-sm text-white/70">3 blocks from Parque Morazán, Matagalpa, Nicaragua</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-global-line text-gold text-sm w-4 h-4 flex items-center justify-center shrink-0" />
                  <a href="https://www.Montebrisa.com" target="_blank" rel="nofollow noopener noreferrer" className="font-sans text-sm text-white/70 hover:text-gold transition-colors">www.Montebrisa.com</a>
                </li>
                <li className="mt-4">
                  <button onClick={() => scrollTo('#contact')} className="px-5 py-2 border border-gold text-gold text-sm font-sans tracking-widest uppercase rounded-md hover:bg-gold hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap">
                    Submit Inquiry
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10 py-5 px-6 md:px-12">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-sans text-xs text-white/35">© {new Date().getFullYear()} Montebrisa Boutique B&amp;B · Matagalpa, Nicaragua. All rights reserved.</p>
          <p className="font-sans text-xs text-white/35">Designed with care in Nicaragua 🇳🇮</p>
        </div>
      </div>
    </footer>
  );
}
